import { Box, Button, Typography } from "@mui/material";

import { CenteredLayout } from "@components/layout/CenteredLayout";
import { GetStaticPropsContext } from "next";
import Head from "next/head";
import Image from "next/image";
import Link from "next/link";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

/**
 * Custom 404 Page.
 *
 * @see https://nextjs.org/docs/advanced-features/custom-error-page
 *
 *
 * @returns custom 404 page
 */
export default function Custom404Page() {
  return (
    <>
      <Head>
        <title>Not Found - myCargill</title>
        <meta name="robots" content="noindex" />
      </Head>
      <CenteredLayout>
        <Box
          sx={{ display: "grid", gridColumn: "1", gridRow: "3", gap: "3rem" }}
        >
          <Box>
            <Image
              src={"/assets/images/page-not-found.svg"}
              alt="Page Not Found"
              width={500}
              height={302}
              priority={true}
            />
            <Typography
              sx={{
                textAlign: "center",
                fontSize: "0.9rem",
                textTransform: "uppercase",
                color: "#999",
              }}
            >
              404 Not Found
            </Typography>
          </Box>
          <Box sx={{ marginTop: "2rem" }}>
            <Typography variant="h2" sx={{ textAlign: "center" }}>
              Page Not Found
            </Typography>
            <Typography sx={{ textAlign: "center" }}>
              Sorry, the page you were looking for was not found.
            </Typography>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Button LinkComponent={Link} href="/?from-404">
              Go back home
            </Button>
          </Box>
        </Box>
      </CenteredLayout>
    </>
  );
}

export async function getStaticProps(context: GetStaticPropsContext) {
  return {
    props: {
      ...(await serverSideTranslations(context.locale as string, [
        "landing",
        "common",
        "apps",
      ])),
    },
  };
}
